/**
 * @desc 分页
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageChannel.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageChannel/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
